import { render, staticRenderFns } from "./BalanceRefreshResultDialog.vue?vue&type=template&id=1b2d3f0e&scoped=true&"
import script from "./BalanceRefreshResultDialog.vue?vue&type=script&lang=js&"
export * from "./BalanceRefreshResultDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2d3f0e",
  null
  
)

export default component.exports